import Button from "@components/global/new/Button/Button";
import { useIntl } from "react-intl";
import styles from "./MinerInstallDate.module.scss";
import { IMinerInstallDateProps } from "./MinerInstallDate.props";
import { useMinerInstallDateControl } from "./useMinerInstallDateControl";
import { MINER_SETTINGS_E } from "@services/getMinerList";
import InstallationField from "@components/global/new/InstallationField/InstallationField";

export default function MinerInstallDate(props: IMinerInstallDateProps) {
  const { formatMessage } = useIntl();
  const control = useMinerInstallDateControl(props);

  if (!control.isAdmin) return null;

  return (
    <InstallationField
      id={MINER_SETTINGS_E.MINER_INSTALATION_DATE}
      placeholder=''
      installDate={Number(control.miner.installed)}
      getDate={control.onGetDate}
    />
  );
}
